<div class="previewContent" (insClickOutside)="handleClickOutside()">
  @switch (type) {
    @case ('image') {
      <div class='contentContainer'>
        <img #image [src]="path" alt="preview icon">
      </div>
    }
    @case ('video') {
      <div  class='contentContainer'>
        <video controls autoplay>
          <source [src]="path" [type]="specificType">
        </video>
      </div>
    }
    @case ('pdf') {
      <div  class='contentContainerForPDF'>
        <object class="pdfViewer" [data]="safePath" type="application/pdf">
          <embed [src]="safePath" type="application/pdf" />
        </object>
      </div>
    }
    @default {
      <div class='contentContainerIframe'>
        <iframe [src]="safePath" [width]="width" [height]="height" allow="autoplay" title="Content Frame"></iframe>
      </div>
    }
  }
</div>

